import { showToast } from "../../../../features/ui"
import { DocumentFooters, DocumentKey, DocumentPaymentTypeIds, DocumentPaymentTypeIdsData } from "../../../administration"
import { useSalesActions } from "../../actions/salesActions"
import { useSalesHooks } from "../../hooks/salesHooks"

export const useActions = () => {
    const { getSettings } = useSalesHooks()
    
    const salesActions = useSalesActions()
    
    const onUpdateSettings = () => showToast('La configuración fue actualizada.')

    const updateDocumentFooter = async (key: DocumentKey, footer: string) => {
        const documentFooters = (getSettings()?.documentFooters || {}) as DocumentFooters
        const newDocumentFooters = { ...documentFooters, [key]: footer }
        await salesActions().saveSalesSetting('documentFooters', newDocumentFooters)
        onUpdateSettings()
    }

    const submitDocumentPaymentTypeIds = async (key: DocumentKey, data: DocumentPaymentTypeIdsData) => {
        const documentPaymentTypeIds = (getSettings()?.documentPaymentTypeIds || {}) as DocumentPaymentTypeIds
        const newDocumentPaymentTypeIds = { ...documentPaymentTypeIds, [key]: data }
        await salesActions().saveSalesSetting('documentPaymentTypeIds', newDocumentPaymentTypeIds)
        onUpdateSettings()
    }

    const submitGeneralHoardTermMonths = async (generalHoardTermMonths: number) => {
        await salesActions().saveSalesSetting('generalHoardTermMonths', generalHoardTermMonths)
        onUpdateSettings()
    }

    const submitChangeMultiple = async (changeMultiple: number) => {
        await salesActions().saveSalesSetting('changeMultiple', changeMultiple)
        onUpdateSettings()
    }

    const submitIgnoreProduct = async (productId: string) => {
        const hoardIgnoredProductIds = (getSettings()?.hoardIgnoredProductIds || []) as string[]
        const newProductIds = hoardIgnoredProductIds.concat(productId)
        await salesActions().saveSalesSetting('hoardIgnoredProductIds', newProductIds)
        onUpdateSettings()
    }

    const submitUnignoreProduct = async (productId: string) => {
        const hoardIgnoredProductIds = (getSettings()?.hoardIgnoredProductIds || []) as string[]
        const newProductIds = hoardIgnoredProductIds.filter(id => id !== productId)
        await salesActions().saveSalesSetting('hoardIgnoredProductIds', newProductIds)
        onUpdateSettings()
    }

    return {
        updateDocumentFooter,
        submitDocumentPaymentTypeIds,
        submitGeneralHoardTermMonths,
        submitChangeMultiple,
        submitIgnoreProduct,
        submitUnignoreProduct
    }
}
